import React, { Component } from "react";

import { withRouter } from "react-router";
import styled from "styled-components";
import { Divider } from "reakit";
import { Box, Button, Flex, Heading, Image, Text } from "rebass";
import { height, maxHeight } from "styled-system";
import HealthSubmission from "../../components/Modals/HealthSubmission";

// Custom Components
import {
  Content,
  DesktopBox,
  MobileBox,
  MobileHeader,
} from "../../components/Base";
import { FloatingButton } from "../../components/Base/Buttons";
import check from "../../resources/img/icons/Checkbox@1x.png";

/**
 * Theme
 */
const PageTitle = styled(Heading)`
  font-size: 24px;
  font-weight: 700;
  color: #263039;
  & > span {
    color: #969a9b;
  }
`;

const ListWrapper = styled(Box)`
  ${maxHeight}
  ${height}
`;

ListWrapper.defaultProps = {
  height: ["calc(100vh - 112px)", "calc(100vh - 71px)"],
};

const StyledButton = styled(Button)`
  border-radius: 43.881px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16);
  width: 167px;
  height: 50px;
  overflow: hidden;
`;

const symptoms = [
"Fever or chills",
"Cough",
"Shortness of breath or difficulty breathing",
"Fatigue",
"Muscle or body aches",
"Headache",
"New loss of taste or smell",
"Sore throat",
"Congestion or runny nose",
"Nausea or vomiting",
"Diarrhea"
]

class NewHealth extends Component {
  state = {
    sick: false,
    symptomInfo: symptoms.map(function(symptom) {
      return {value: symptom, isChecked: false}
    }),
    truth: false,
    healthy: null,
    submitted: false,
    isUpdate: false,
    userRef: null,
    showSubmissionMessage: false,
    submissionMessageHealthy: null,
  };

  componentDidMount() {
    const { profile, isFaculty } = this.props;
    let today = new Date();
    today.setHours(0, 0, 0, 0);
    let todayEpoch = Math.floor(today.getTime() / 1000);

    if (isFaculty) {
      this.healthSubmissionListener = this.props.firebase
        .faculty(profile.id)
        .onSnapshot((snapshot) => {
          let user = snapshot.data();
          if (user) {
            this.setState({
              healthy: user.healthy,
              submitted: user.health_last_updated > todayEpoch,
              isUpdate: user.health_last_updated > todayEpoch,
              userRef: snapshot.ref,
            });
          }
        });
    } else {
      this.healthSubmissionListener = this.props.firebase
        .student(profile.id)
        .onSnapshot((snapshot) => {
          let user = snapshot.data();
          if (user) {
            this.setState({
              healthy: user.healthy,
              submitted: user.health_last_updated > todayEpoch,
              isUpdate: user.health_last_updated > todayEpoch,
              userRef: snapshot.ref,
            });
          }
        });
    }
  }

  componentWillUnmount() {
    this.healthSubmissionListener();
  }

  handleCheckbox = (event) => {
    const target = event.target;
    const value = target.checked;
    const name = target.name;

    this.setState({
      [name]: value,
    });
  };

  handleCheckSymptom = (event) => {
    const target = event.target;
    const value = target.checked;
    const name = target.name;
    let symptomInfo = this.state.symptomInfo
    symptomInfo.forEach((symptom) => {
      if (symptom.value === name) {
        symptom.isChecked = value
      }
    })
    this.setState({ symptomInfo: symptomInfo })

    if (value && !this.state.sick) {
      this.setState({ sick: true })
    }
  }

  handleSubmit = async () => {
    const { sick, symptomInfo, isUpdate, userRef } = this.state;
    try {
      let submissionTime = Math.floor(Date.now() / 1000);

      // Construct symptomInfo array
      let symptomsInfoArray = []
      symptomInfo.forEach((info) => info.isChecked ? symptomsInfoArray.push(info.value) : null)
  
      if (sick) {
        userRef.update({
          healthy: false,
          health_last_updated: submissionTime,
        });
        this.setState({ submissionMessageHealthy: false });
      } else {
        userRef.update({
          healthy: true,
          health_last_updated: submissionTime,
        });
        this.setState({ submissionMessageHealthy: true });
      }

      let healthRef = userRef.collection("health_history");
      if (isUpdate) {
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        let todayEpoch = Math.floor(today.getTime() / 1000);
        let tmrEpoch = todayEpoch + 86400;
        await healthRef
          .where("post_time", ">=", todayEpoch)
          .where("post_time", "<", tmrEpoch)
          .limit(1)
          .get()
          .then((snapshot) => {
            snapshot.docs.forEach((doc) => {
              doc.ref.update({
                sick: sick,
                symptomInfo: symptomsInfoArray,
                post_time: submissionTime,
              });
            });
          });
      } else {
        let newHealth = healthRef.doc();
        newHealth.set({
          sick: sick,
          symptomInfo: symptomsInfoArray,
          post_time: submissionTime,
        });
      }

      this.setState({
        sick: false,
        symptomInfo: symptoms.map(function(symptom) {
          return {value: symptom, isChecked: false}
        }),
        temp: false,
        submitted: true,
        showSubmissionMessage: true,
      });
    } catch (error) {
      console.log(error);
    }
  };

  handleTogglePopover() {
    this.setState({ showSubmissionMessage: false });
    this.props.history.push("/app/home");
  }

  render() {
    const {
      sick,
      symptomInfo,
      truth,
      submitted,
      healthy,
      showSubmissionMessage,
      submissionMessageHealthy,
    } = this.state;

    let disabled = !truth;

    return (
      <Box p={[0, 3]}>
        <MobileHeader paddingLeft={"0px"} paddingRight={"0px"}>
          <Box px={"24px"} pb={"10px"}>
            <PageTitle>
              {submitted ? (
                healthy ? (
                  <Text style={{ color: "#2BB99E" }}>HEALTHY</Text>
                ) : (
                  <Text style={{ color: "#F95050" }}>UNHEALTHY</Text>
                )
              ) : (
                <div>Daily Health Form</div>
              )}
            </PageTitle>
          </Box>
        </MobileHeader>
        <Content fontWeight={600}>
          <Flex flexWrap={"wrap"}>
            <MobileBox>
              <FloatingButton
                bg={disabled ? "meta" : "purple"}
                disabled={disabled}
                onClick={this.handleSubmit}
              >
                <Image src={check} />
              </FloatingButton>
            </MobileBox>
            <DesktopBox mb={3} width={1}>
              <Flex width={1} alignItems={"center"}>
                <Box mb={4}>
                  <StyledButton
                    onClick={this.handleSubmit}
                    m={1}
                    bg={disabled ? "gray" : "purple"}
                    disabled={disabled}
                  >
                    {"Submit"}
                  </StyledButton>
                </Box>
              </Flex>
              <Text
                style={{ marginTop: "-0.5em" }}
                pt={3}
                fontSize={"32px"}
                fontWeight={800}
                lineHeight={1}
              >
                {submitted ? (
                  healthy ? (
                    <Text style={{ color: "#2BB99E" }}>HEALTHY</Text>
                  ) : (
                    <Text style={{ color: "#F95050" }}>UNHEALTHY</Text>
                  )
                ) : (
                  <div>Daily Health Form</div>
                )}
              </Text>
            </DesktopBox>

            <HealthSubmission
              {...this.props}
              visible={showSubmissionMessage}
              toggle={() => this.handleTogglePopover()}
              healthy={submissionMessageHealthy}

            />
            {/*
            <Box pl={3}>
              <Text py={3} fontSize={"16px"} fontWeight={600}>
                <input
                  style={{ marginRight: "0.5em" }}
                  name={"around"}
                  type="checkbox"
                  checked={around}
                  onChange={this.handleCheckbox}
                />
                Have you been around someone who is sick?
              </Text>
            </Box>

            <Box width={1}>
              <Divider margin={0} padding={0} />
            </Box>

            <Box pl={3}>
              <Text py={3} fontSize={"16px"} fontWeight={600}>
                <input
                  style={{ marginRight: "0.5em" }}
                  name={"exposed"}
                  type="checkbox"
                  checked={exposed}
                  onChange={this.handleCheckbox}
                />
                Have you been exposed in the last three days to someone who has COVID-19 or COVID-like symptoms?
              </Text>
            </Box>
            */}

            <Box width={1}>
              <Divider margin={0} padding={0} />
            </Box>

            <Box pl={3}>
              <Text py={3} fontSize={"16px"} fontWeight={600}>
                <input
                  style={{ marginRight: "0.5em" }}
                  name={"sick"}
                  type="checkbox"
                  checked={sick}
                  onChange={this.handleCheckbox}
                />
                Are you feeling sick?
              </Text>
            </Box>

            <Box width={1}>
              <Divider margin={0} padding={0} />
            </Box>

            <Box pl={3}>
              <Text py={3} fontSize={"16px"} fontWeight={600}>
                If sick, check any symptoms you have:
              </Text>
              {symptomInfo.map((symptom) => {
                return <div>
                  <input
                  style={{ marginRight: "0.5em" }}
                  name={symptom.value}
                  type="checkbox"
                  checked={symptom.isChecked}
                  onChange={this.handleCheckSymptom}
                  />
                  <>{symptom.value}</>
                </div>
              })}
              <br />
            </Box>

            <Box width={1}>
              <Divider margin={0} padding={0} />
            </Box>

            <Box pl={3}>
              <Text py={3} fontSize={"16px"} fontWeight={600}>
                <input
                  style={{ marginRight: "0.5em" }}
                  name={"truth"}
                  type="checkbox"
                  checked={truth}
                  onChange={this.handleCheckbox}
                />
                I AFFIRM THE ABOVE STATEMENTS ARE TRUE TO MY KNOWLEDGE.
              </Text>
            </Box>
          </Flex>
        </Content>
      </Box>
    );
  }
}

export default withRouter(NewHealth);
